import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { map } from 'rxjs/operators';
import { GlobalService } from 'src/app/shared/services/global.service';
import { ApplicationNameService } from 'src/app/shared/services/application-name.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { BaseComponent } from 'src/app/core/base-classes/base/base.component';

@Component({
    selector: 'fury-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class FooterComponent extends BaseComponent implements OnInit {

  public visible$ = this._themeService.config$.pipe(map(config => config.footerVisible));
  public copyrightYear = new Date().getFullYear();
  public isRkon: boolean = false;

  constructor(
    private _themeService: ThemeService,
    private _globalService: GlobalService,
    public applicationNameService: ApplicationNameService
  ) {
    super();
    this.isRkon = this._globalService.isRkon;
  }

  ngOnInit() {
  }

  hide() {
    this._themeService.setFooterVisible(false);
  }
}
